import { FacetedManager } from './FacetedManager.component';

export { FacetedManager };
